// extracted by mini-css-extract-plugin
export default {"wrap":"VideosPage_wrap__KU-J4","itemWrap":"VideosPage_itemWrap__2WmV3","itemDelete":"VideosPage_itemDelete__OfPSg"};